<template>
  <div class="layout-container">
    <FrontendLayoutHeader />
    <main class="main-content">
      <slot />
    </main>
    <LazyPartialsCommonFooter />
  </div>
</template>

<script setup>
await useSiteMeta()

// Mobil cihazlarda viewport height sorununu çözmek için
const setVH = () => {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

onMounted(() => {
  setVH()
  window.addEventListener('resize', setVH, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('resize', setVH)
})
</script>

<style scoped>
/* Smooth scroll behavior */
html {
  scroll-behavior: smooth;
}

/* Global transitions */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}

/* Pattern dots */
.pattern-dots {
  background-image: radial-gradient(currentColor 1px, transparent 1px);
  background-size: 12px 12px;
}

.layout-container {
  min-height: 100vh;
  min-height: 100dvh; /* dynamic viewport height */
  display: flex;
  flex-direction: column;
  background-color: rgb(var(--color-gray-50));
}

.main-content {
  flex: 1;
  padding-bottom: env(safe-area-inset-bottom);
  /* Mobile için ekstra padding */
  @media (max-width: 768px) {
    padding-bottom: calc(
      env(safe-area-inset-bottom) + 56px
    ); /* 56px yaklaşık navigation bar yüksekliği */
  }
}
</style>
